import { cva, type VariantProps } from "class-variance-authority";
import { ButtonHTMLAttributes, forwardRef } from "react";

import { cn } from "../lib/cn";

const buttonVariants = cva(
  "inline-flex w-full items-center justify-center gap-2 rounded transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary:
          "h-control-lg px-4 text-body-lg font-medium bg-primary text-on-primary enabled:hover:shadow-hover focus-visible:ring-primary disabled:bg-surface-muted disabled:text-ink-tertiary disabled:opacity-100",
        secondary:
          "h-control-lg px-4 text-body-lg font-medium border border-border bg-surface text-ink enabled:hover:border-border-control enabled:hover:shadow-hover active:bg-surface-pressed focus-visible:ring-focus-ring disabled:text-ink-tertiary",
        text: "min-h-11 px-3 text-body-medium text-ink underline decoration-border underline-offset-4 hover:decoration-ink focus-visible:ring-focus-ring disabled:text-ink-tertiary disabled:no-underline",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
);

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant }), className)}
      {...props}
    />
  )
);

Button.displayName = "Button";
